<!--
 * 严肃声明：
 * 开源版本请务必保留此注释头信息，若删除我方将保留所有法律责任追究！
 * 本系统已申请软件著作权，受国家版权局知识产权以及国家计算机软件著作权保护！
 * 可正常分享和学习源码，不得用于违法犯罪活动，违者必究！
 * Copyright (c) 2020 陈尼克 all rights reserved.
 * 版权所有，侵权必究！
 *
-->

<template>
  <div class="order-detail-box">
    <s-header :name="'订单详情'" :back="'/order'" @callback="close"></s-header>
    <div class="order-status">
      <div class="status-item" v-if="detail.countdown > 0">
        <van-count-down :time="detail.countdown" @finish="finish">
          <template v-slot="timeData">
            <span> 请在 </span>
            <span class="item">{{ timeData.hours }}</span>
            <span class="item">:</span>
            <span class="item">{{ timeData.minutes }}</span>
            <span class="item">:</span>
            <span class="item">{{ timeData.seconds }}</span>
            <span> 完成支付 </span>
          </template>
        </van-count-down>
      </div>

      <div class="status-item">
        <label>订单状态：</label>
        <span>{{ detail.orderStatusString }}</span>
      </div>
      <div class="status-item">
        <label>订单编号：</label>
        <span>{{ detail.orderNo }}</span>
      </div>
      <div class="status-item">
        <label>下单时间：</label>
        <span>{{ detail.createTime }}</span>
      </div>
      <!-- <van-button v-if="[1,2,3].includes(detail.orderStatus)" style="margin-bottom: 10px" color="#1baeae" block @click="confirmOrder(detail.orderNo)">确认订单</van-button> -->
      <van-button
        v-if="detail.orderStatus == 0"
        style="margin-bottom: 10px"
        type="primary"
        color="#40c6ff"
        block
        @click="showPayFn"
        >去支付</van-button
      >
      <van-button
        v-if="
          !(
            detail.orderStatus < 0 ||
            detail.orderStatus == 4 ||
            detail.orderStatusString === '已支付'
          )
        "
        block
        @click="handleCancelOrder(detail.orderNo)"
        >取消订单</van-button
      >
    </div>
    <div class="order-price">
      <div class="price-item">
        <label>商品金额：</label>
        <span>¥ {{ detail.payPrice }}</span>
      </div>
      <div class="price-item">
        <label>配送方式：</label>
        <span>普通快递</span>
      </div>
    </div>
    <van-card
      v-for="item in detail.newBeeMallOrderItemVOS"
      :key="item.goodsId"
      style="background: #fff"
      :num="item.goodsCount"
      :price="item.payPrice+'.00'"
      :desc="item.collection"
      :origin-price="item.sellingPrice>item.payPrice?item.sellingPrice:none"

      :title="item.goodsName"
      :thumb="$filters.prefix(item.goodsCoverImg)"
    />
    <van-popup
      v-model:show="showPay"
      position="bottom"
      :style="{ height: '12%' }"
    >
      <div :style="{ width: '90%', margin: '0 auto', padding: '20px 0' }">
        <!-- <van-button :style="{ marginBottom: '10px' }" color="#1989fa" block @click="handlePayOrder(detail.orderNo, 1)">支付宝支付</van-button> -->
        <van-button
          color="#4fc08d"
          block
          @click="handlePayOrder(detail.orderNo, detail.payPrice,detail.sign)"
          >微信支付</van-button
        >
      </div>
    </van-popup>
  </div>
</template>
<script>
import { reactive, toRefs, onMounted } from 'vue'
import sHeader from '@/components/SimpleHeader'
import {
  getOrderDetail,
  cancelOrder,
  confirmOrder,
  isCoupon
} from '@/service/order'
import { Dialog, Toast } from 'vant'
import { useRoute } from 'vue-router'
export default {
  name: 'OrderDetail',
  components: {
    sHeader
  },
  setup() {
    const route = useRoute()
    const state = reactive({
      detail: {},
      showPay: false
    })

    onMounted(() => {
      init()
    })

    const init = async () => {
      Toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      const { id } = route.query
      const { data } = await getOrderDetail(id)
      state.detail = data
      Toast.clear()
    }

    const handleCancelOrder = (id) => {
      Dialog.confirm({
        title: '确认取消订单？'
      })
        .then(() => {
          cancelOrder(id).then((res) => {
            if (res.resultCode == 200) {
              Toast('删除成功')
              init()
            }
          })
        })
        .catch(() => {})
    }

    const handleConfirmOrder = (id) => {
      Dialog.confirm({
        title: '是否确认订单？'
      })
        .then(() => {
          confirmOrder(id).then((res) => {
            if (res.resultCode == 200) {
              Toast('确认成功')
              init()
            }
          })
        })
        .catch(() => {
          // on cancel
        })
    }

    const showPayFn = () => {
      const { orderNo } = state.detail

      isCoupon(orderNo).then((res) => {
        if (res.resultCode === 500) {
          state.showPay = false
          Toast.fail(res.message)
        } else if (res.resultCode === 200) {
          state.detail.totalPrice = res.data.totalPrice
          state.showPay = true
        }
      })
    }

    // const handlePayOrder = async (id, type) => {
    //   Toast.loading
    //   await payOrder({ orderNo: id, payType: type })
    //   state.showPay = false
    //   init()
    // }
    const handlePayOrder = (orderId, orderAmount, sign) => {
      console.log(sign)
      console.log('支付中....')
      let orderNo = orderId
      let amount = orderAmount
      window.wx.miniProgram.navigateTo({
        url: `/pages/pay/index?orderId=${orderNo}&amount=${amount}&sign=${sign}`
      })
    }

    const close = () => {
      Dialog.close()
    }

    const finish = () => {
      state.detail.orderStatus = -2 // 超时关闭,隐藏相关支付按钮
    }

    return {
      ...toRefs(state),
      handleCancelOrder,
      handleConfirmOrder,
      showPayFn,
      handlePayOrder,
      close,
      finish
    }
  }
}
</script>

<style lang="less" >
.van-card__content {
  justify-content: space-around!important;
}
.van-ellipsis {
  margin-top: 10px;
}
.order-detail-box {
  background: #f7f7f7;
  .order-status {
    background: #fff;
    padding: 20px;
    font-size: 15px;
    .status-item {
      margin-bottom: 10px;
      label {
        color: #999;
      }
      span {
      }
    }
  }
  .order-price {
    background: #fff;
    margin: 20px 0;
    padding: 20px;
    font-size: 15px;
    .price-item {
      margin-bottom: 10px;
      label {
        color: #999;
      }
      span {
      }
    }
  }
  .van-card {
    margin-top: 0;
  }
  .van-card__content {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .item {
    color: #fff;
    background-color: #fa1924;
  }
}
</style>
